/**
 * A rosette pendant marking a flow as part of the dental pilot journey.
 *
 * Ported from option 6c of the "Dental Badge Ideas" Claude Design session —
 * paths, gradient stops, sizes and shadow are the design's, not approximated.
 * The hex values are deliberately kept rather than mapped onto brand-amber
 * (#f59e0b): the gradient is a designed pair and the token isn't either stop.
 *
 * Hangs half off the bottom edge of the welcome card, which is already
 * `relative` and `overflow-visible` so the overhang isn't clipped. It sits
 * there rather than in the page's top corners because the report and close
 * controls live there, and anything beside them reads as a third button.
 *
 * Decorative, so hidden from assistive tech, and `pointer-events-none` — it
 * straddles the card's edge, so it must never swallow a tap meant for the
 * card or for whatever the overhang covers.
 */
import { TOOTH_PATH } from "@/features/dental/components/ToothIcon";

// Verbatim from the design file. Do NOT wrap these across lines: path
// data has no statement separator, so joining two fragments fuses the
// numbers at the seam (-2.1 + 1.6 becomes -2.11.6) and silently warps
// the shape — nothing in the type system or the build catches it.
const ROSETTE_PATH =
  "M22 1l3.6 3 4.6-1 2 4.3 4.6 1-.4 4.7 3.8 2.8-2.6 3.9 1.6 4.4-4.2 2.1-.7 4.7-4.7-.3-2.9 3.7L22 32l-4.7 2.3-2.9-3.7-4.7.3-.7-4.7-4.2-2.1 1.6-4.4-2.6-3.9 3.8-2.8-.4-4.7 4.6-1 2-4.3 4.6 1z";

export function DentalJourneySeal() {
  return (
    <span
      aria-hidden="true"
      className="pointer-events-none absolute -bottom-6 left-1/2 z-10 flex h-12 w-12 -translate-x-1/2 items-center justify-center"
      style={{ filter: "drop-shadow(0 2px 5px rgba(232,134,46,.35))" }}
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 44 44"
        className="absolute inset-0"
      >
        <defs>
          <linearGradient id="dentalSealGradient" x1="0" y1="0" x2="44" y2="44">
            <stop stopColor="#f8b62d" />
            <stop offset="1" stopColor="#e8862e" />
          </linearGradient>
        </defs>
        <path
          d={ROSETTE_PATH}
          fill="url(#dentalSealGradient)"
          transform="translate(0,4)"
        />
      </svg>
      <svg
        width="23"
        height="23"
        viewBox="0 0 24 24"
        fill="none"
        className="relative mt-0.5"
      >
        <path d={TOOTH_PATH} fill="#fff" />
      </svg>
    </span>
  );
}
